import { displayRequestRef } from "../../../../../utils.js";

export const getDefaultTableColumnDef = () => ({
    requests_id: {
        label: TRAD.id_dossier,
        visibility: false
    },
    ref_hotel: {
        label: TRAD.ref_hotel_main,
        visibility: false
    },
    date_activated: {
        label: TRAD.date_activated,
        visibility: true
    },
    source: {
        label: TRAD.source,
        visibility: false
    },
    hotels_title: {
        label: TRAD.hotel,
        visibility: true
    },
    property_ref: {
        label: TRAD.property_ref,
        visibility: false
    },
    rh_status: {
        label: TRAD.status,
        visibility: true
    },
    decline_cause: {
        label: TRAD.decline_cause,
        visibility: false
    },
    decline_cause_details: {
        label: TRAD.decline_cause_details,
        visibility: false
    },
    nb_night: {
        label: TRAD.nb_night,
        visibility: false
    },
    nb_nuitees: {
        label: TRAD.nb_nuitees,
        visibility: false
    },
    nb_nuitees_devis: {
        label: TRAD.nb_nuitees_devis,
        visibility: false
    },
    checkin: {
        label: TRAD.checkin,
        visibility: false
    },
    checkout: {
        label: TRAD.checkout,
        visibility: false
    },
    month: {
        label: TRAD.mois,
        visibility: true
    },
    year: {
        label: TRAD.annee,
        visibility: false
    },
    quantity: {
        label: TRAD.nombre_demande,
        visibility: true
    },
    nb_pax: {
        label: TRAD.nb_pax,
        visibility: false
    },
    requests_price: {
        label: TRAD.budget_client,
        visibility: false
    },
    ca_request: {
        label: TRAD.ca_requests,
        visibility: false
    },
    total_ht: {
        label: TRAD.total_ht,
        visibility: true
    },
    total_ttc: {
        label: TRAD.total_ttc,
        visibility: false
    },
    subtotal_accomodation_ht: {
        label: TRAD.subtotal_accomodation_ht,
        visibility: true
    },
    subtotal_accomodation_ttc: {
        label: TRAD.subtotal_accomodation_ttc,
        visibility: false
    },
    subtotal_restauration_ht: {
        label: TRAD.subtotal_restauration_ht,
        visibility: true
    },
    subtotal_restauration_ttc: {
        label: TRAD.subtotal_restauration_ttc,
        visibility: false
    },
    subtotal_meeting_ht: {
        label: TRAD.subtotal_meeting_ht,
        visibility: true
    },
    subtotal_meeting_ttc: {
        label: TRAD.subtotal_meeting_ttc,
        visibility: false
    },
    subtotal_other_ht: {
        label: TRAD.subtotal_other_ht,
        visibility: true
    },
    subtotal_other_ttc: {
        label: TRAD.subtotal_other_ttc,
        visibility: false
    },
    subtotal_reductions_ht: {
        label: TRAD.subtotal_reductions_ht,
        visibility: false
    },
    subtotal_reductions_ttc: {
        label: TRAD.subtotal_reductions_ttc,
        visibility: false
    },
    subtotal_tourist_tax: {
        label: TRAD.subtotal_tourist_tax,
        visibility: false
    },
    date_devis: {
        label: TRAD.date_devis,
        visibility: false
    },
    delais_reponse_devis: {
        label: TRAD.date_diff_rh,
        visibility: false
    },
    type_groupe: {
        label: TRAD.type_groupe,
        visibility: false
    },
    client: {
        // label: capitalize(TRAD.entreprise),
        label: TRAD.entreprise,
        visibility: false
    },
    client_prenom: {
        label: TRAD.client_prenom,
        visibility: false
    },
    client_nom: {
        label: TRAD.client_nom,
        visibility: false
    },
    client_email: {
        label: TRAD.client_email,
        visibility: false
    },
    client_langue: {
        label: TRAD.client_langue,
        visibility: false
    },
    client_pays: {
        label: TRAD.client_pays,
        visibility: false
    },
    client_profile: {
        label: TRAD.client_compte,
        visibility: false
    },
    business_introducer_prenom: {
        label: TRAD.business_introducer_prenom,
        visibility: false
    },
    business_introducer_nom: {
        label: TRAD.business_introducer_nom,
        visibility: false
    },
    business_introducer_email: {
        label: TRAD.business_introducer_email,
        visibility: false
    },
    business_introducer_langue: {
        label: TRAD.business_introducer_langue,
        visibility: false
    },
    business_introducer_pays: {
        label: TRAD.business_introducer_pays,
        visibility: false
    },
    business_introducer_groupe: {
        label: TRAD.business_introducer_groupe,
        visibility: false
    },
    business_introducer_groupe_type: {
        label: TRAD.business_introducer_groupe_type,
        visibility: false
    },
    business_introducer: {
        label: TRAD.business_introducer,
        visibility: false
    },
    business_introducer_retrocession: {
        label: TRAD.business_introducer_retrocession,
        visibility: false
    },
    business_introducer_estimated_commission: {
        label: TRAD.business_introducer_estimated_commission,
        visibility: false
    },
    destination: {
        label: TRAD.destination,
        visibility: false
    },
    segment: {
        label: TRAD.segment,
        visibility: false
    },
    manager_requests: {
        label: TRAD.manager_requests,
        visibility: false
    },
    manager_requests_hotels: {
        label: TRAD.manager_requests_hotels,
        visibility: false
    },
    ref_client: {
        label: TRAD.ref_client,
        visibility: false
    },
    facturation_name: {
        label: TRAD.facturation_name,
        visibility: false
    },
    facturation_address: {
        label: TRAD.facturation_address,
        visibility: false
    },
    facturation_postalcode: {
        label: TRAD.facturation_postalcode,
        visibility: false
    },
    facturation_city: {
        label: TRAD.facturation_city,
        visibility: false
    },
    facturation_country: {
        label: TRAD.facturation_country,
        visibility: false
    },
    requests_type: {
        label: TRAD.requests_type_slug,
        visibility: false
    },
    reservation_date: {
        label: TRAD.reservation_date,
        visibility: false
    },
    commission_rate: {
        label: TRAD.commission_rate,
        visibility: false
    },
    commission_type: {
        label: TRAD.commission_type,
        visibility: false
    },
    currency: {
        label: TRAD.devise,
        visibility: false
    },
    moderation: {
        label: TRAD.moderation,
        visibility: false
    },
    date_decline: {
        label: TRAD.date_decline,
        visibility: false
    },
    note: {
        label: TRAD.notes,
        visibility: false
    },
    forms_requests_name: {
        label: TRAD.formulaire,
        visibility: false
    }
})

export const getDefaultTableColumnVisibility = (state = undefined) => {
    let columnVisibility = {};
    const defaultTableColumnDef = getDefaultTableColumnDef();
    Object.entries(defaultTableColumnDef).map(([id, item]) => (
        columnVisibility[id] = (state !== undefined ? state : item.visibility)
    ));
    return columnVisibility;
}

export const formatTableExportData = (columns, rows, columnDef = null, tableCols = null) => {
    let exportData = [];
    let exportCols = {};
    if (columnDef) {
        Object.entries(columnDef).map(([id, item]) => {
            if (item.value) exportCols[id] = item.label;
        });
    } else if (tableCols) {
        tableCols.map((col) => exportCols[col.id] = col.column?.columnDef?.header)
    } else {
        Object.entries(columns).map(([id, item]) => exportCols[id] = item.label);
    }

    rows.map((row) => {
        let exportRow = {};
        if (tableCols) row = row.original;
        /* 0 */ if (exportCols.requests_id) exportRow[exportCols.requests_id] = displayRequestRef(row.requests_id);
        /* 1 */ if (exportCols.ref_hotel) exportRow[exportCols.ref_hotel] = row.requests_hotels_ref_hotel ?? '';
        /* 2 */ if (exportCols.date_activated) exportRow[exportCols.date_activated] = new Date(row.requests_hotels_date_activated);
        /* 3 */ if (exportCols.source) exportRow[exportCols.source] = row.source;
        /* 4 */ if (exportCols.hotels_title) exportRow[exportCols.hotels_title] = row.hotels_title;
        /* 5 */ if (exportCols.property_ref) exportRow[exportCols.property_ref] = row.hotels_property_ref ?? '';
        /* 6 */ if (exportCols.rh_status) exportRow[exportCols.rh_status] = row.requests_hotels_status_key_trad;
        /* 7 */ if (exportCols.decline_cause) exportRow[exportCols.decline_cause] = row.requests_hotels_decline_causes_key_trad ?? '';
        /* 8 */ if (exportCols.decline_cause_details) exportRow[exportCols.decline_cause_details] = row.requests_hotels_decline_causes_details ? row.requests_hotels_decline_causes_details.replace(/(\r\n|\n|\r)/gm, "") : '';
        /* 9 */ if (exportCols.nb_night) exportRow[exportCols.nb_night] = row.nb_night;
        /* 10 */ if (exportCols.nb_nuitees) exportRow[exportCols.nb_nuitees] = row.nb_nuitee;
        /* 11 */ if (exportCols.nb_nuitees_devis) exportRow[exportCols.nb_nuitees_devis] = row.nb_nuitee_devis;
        /* 12 */ if (exportCols.checkin) exportRow[exportCols.checkin] = new Date(row.requests_hotels_checkin ?? row.requests_checkin);
        /* 13 */ if (exportCols.checkout) exportRow[exportCols.checkout] = new Date(row.requests_hotels_checkout ?? row.requests_checkout);
        /* 14 */ //if (exportCols.month) exportRow[exportCols.month] = row.month;
        /* 15 */ //if (exportCols.year]) exportRow[exportCols.year] = row.year;
        /* 16 */ //if (exportCols.quantity]) exportRow[exportCols.quantity] = quantity;
        /* 17 */ if (exportCols.nb_pax) exportRow[exportCols.nb_pax] = row.nb_pax;
        /* 18 */ if (exportCols.requests_price) exportRow[exportCols.requests_price] = row.requests_price > 0 ? parseFloat(row.requests_price).toFixed(2) : '';
        /* 19 */ if (exportCols.ca_request) exportRow[exportCols.ca_request] = row.ca_request > 0 ? parseFloat(row.ca_request).toFixed(2) : '';
        /* 20 */ if (exportCols.total_ht) exportRow[exportCols.total_ht] = parseFloat(row.products_orders_total_providers_ht ?? 0).toFixed(2);
        /* 21 */ if (exportCols.total_ttc) exportRow[exportCols.total_ttc] = parseFloat(row.products_orders_total_ht ?? 0).toFixed(2);
        /* 22 */ if (exportCols.subtotal_accomodation_ht) exportRow[exportCols.subtotal_accomodation_ht] = parseFloat(row.products_orders_subtotal_accommodations_ht ?? 0).toFixed(2);
        /* 23 */ if (exportCols.subtotal_accomodation_ttc) exportRow[exportCols.subtotal_accomodation_ttc] = parseFloat(row.products_orders_subtotal_accommodations_ttc ?? 0).toFixed(2);
        /* 24 */ if (exportCols.subtotal_restauration_ht) exportRow[exportCols.subtotal_restauration_ht] = parseFloat(row.products_orders_subtotal_restaurations_ht ?? 0).toFixed(2);
        /* 25 */ if (exportCols.subtotal_restauration_ttc) exportRow[exportCols.subtotal_restauration_ttc] = parseFloat(row.products_orders_subtotal_restaurations_ttc ?? 0).toFixed(2);
        /* 26 */ if (exportCols.subtotal_meeting_ht) exportRow[exportCols.subtotal_meeting_ht] = parseFloat(row.products_orders_subtotal_meetings_ht ?? 0).toFixed(2);
        /* 27 */ if (exportCols.subtotal_meeting_ttc) exportRow[exportCols.subtotal_meeting_ttc] = parseFloat(row.products_orders_subtotal_meetings_ttc ?? 0).toFixed(2);
        /* 28 */ if (exportCols.subtotal_other_ht) exportRow[exportCols.subtotal_other_ht] = parseFloat(row.products_orders_subtotal_others_ht ?? 0).toFixed(2);
        /* 29 */ if (exportCols.subtotal_other_ttc) exportRow[exportCols.subtotal_other_ttc] = parseFloat(row.products_orders_subtotal_others_ttc ?? 0).toFixed(2);
        /* 30 */ if (exportCols.subtotal_reductions_ht) exportRow[exportCols.subtotal_reductions_ht] = parseFloat(row.products_orders_subtotal_reductions_ht ?? 0).toFixed(2);
        /* 31 */ if (exportCols.subtotal_reductions_ttc) exportRow[exportCols.subtotal_reductions_ttc] = parseFloat(row.products_orders_subtotal_reductions_ttc ?? 0).toFixed(2);
        /* 32 */ if (exportCols.subtotal_tourist_tax) exportRow[exportCols.subtotal_tourist_tax] = parseFloat(row.products_orders_subtotal_tourist_tax ?? 0).toFixed(2);
        /* 33 */ if (exportCols.date_devis) exportRow[exportCols.date_devis] = row.date_devis ? new Date(row.date_devis) : '';
        /* 34 */ if (exportCols.delais_reponse_devis) exportRow[exportCols.delais_reponse_devis] = row.delais_reponse_devis ?? '';
        /* 35 */ if (exportCols.type_groupe) exportRow[exportCols.type_groupe] = row.requests_events_key_trad ?? '';
        /* 36 */ if (exportCols.client) exportRow[exportCols.client] = row.requests_final_client_membres_groups_name ?? row.requests_membres_groups_name;
        /* 37 */ if (exportCols.client_prenom) exportRow[exportCols.client_prenom] = row.requests_final_client_surname ?? row.requests_membres_surname;
        /* 38 */ if (exportCols.client_nom) exportRow[exportCols.client_nom] = row.requests_final_client_name ?? row.requests_membres_name;
        /* 39 */ if (exportCols.client_email) exportRow[exportCols.client_email] = row.requests_final_client_email ?? row.requests_membres_email;
        /* 40 */ if (exportCols.client_langue) exportRow[exportCols.client_langue] = row.requests_final_client_langues_title ?? row.requests_membres_langues_title;
        /* 41 */ if (exportCols.client_pays) exportRow[exportCols.client_pays] = row.requests_final_client_pays_title ?? row.requests_membres_pays_title;
        /* 42 */ if (exportCols.client_profile) exportRow[exportCols.client_profile] = row.requests_final_client_membres_groups_organisations_type_key_trad ?? row.requests_membres_groups_organisations_type_key_trad;
        /* 43 */ if (exportCols.business_introducer_prenom) exportRow[exportCols.business_introducer_prenom] = row.business_introducer_surname ?? '';
        /* 44 */ if (exportCols.business_introducer_nom) exportRow[exportCols.business_introducer_nom] = row.business_introducer_name ?? '';
        /* 45 */ if (exportCols.business_introducer_email) exportRow[exportCols.business_introducer_email] = row.business_introducer_email ?? '';
        /* 46 */ if (exportCols.business_introducer_langue) exportRow[exportCols.business_introducer_langue] = row.business_introducer_langues_title ?? '';
        /* 47 */ if (exportCols.business_introducer_pays) exportRow[exportCols.business_introducer_pays] = row.business_introducer_pays_title ?? '';
        /* 48 */ if (exportCols.business_introducer_groupe) exportRow[exportCols.business_introducer_groupe] = row.business_introducer_membres_groups_name ?? '';
        /* 49 */ if (exportCols.business_introducer_groupe_type) exportRow[exportCols.business_introducer_groupe_type] = row.business_introducer_membres_groups_organisations_type_key_trad ?? '';
        /* 50 */ if (exportCols.business_introducer) exportRow[exportCols.business_introducer] = row.requests_membres_groups_business_introducer ? 'yes'.trad() : 'no'.trad();
        /* 51 */ if (exportCols.business_introducer_retrocession) exportRow[exportCols.business_introducer_retrocession] = row.requests_membres_groups_business_introducer ? (row.requests_membres_groups_retrocession ? parseFloat(row.requests_membres_groups_retrocession).toFixed(2) : '') : '';
        /* 52 */ if (exportCols.business_introducer_estimated_commission) exportRow[exportCols.business_introducer_estimated_commission] = row.requests_membres_groups_business_introducer ? (row.estimated_commission ? parseFloat(row.estimated_commission).toFixed(2) : parseFloat(0).toFixed(2)) : '';
        /* 53 */ if (exportCols.destination) exportRow[exportCols.destination] = row.destination ?? '';
        /* 54 */ if (exportCols.segment) exportRow[exportCols.segment] = row.segmentation_label ?? '';
        /* 55 */ if (exportCols.manager_requests) exportRow[exportCols.manager_requests] = row.requests_manager_id ? (row.requests_manager_surname + ' ' + row.requests_manager_name) : '';
        /* 56 */ if (exportCols.manager_requests_hotels) exportRow[exportCols.manager_requests_hotels] = row.requests_hotels_manager_id ? (row.requests_hotels_manager_surname + ' ' + row.requests_hotels_manager_name) : '';
        /* 57 */ if (exportCols.ref_client) exportRow[exportCols.ref_client] = row.requests_ref_client ?? '';
        /* 58 */ if (exportCols.facturation_name) exportRow[exportCols.facturation_name] = row.factures_destinataire ?? '';
        /* 59 */ if (exportCols.facturation_address) exportRow[exportCols.facturation_address] = row.factures_destinataire_address ?? '';
        /* 60 */ if (exportCols.facturation_postalcode) exportRow[exportCols.facturation_postalcode] = row.factures_destinataire_postalcode ?? '';
        /* 61 */ if (exportCols.facturation_city) exportRow[exportCols.facturation_city] = row.factures_destinataire_city ?? '';
        /* 62 */ if (exportCols.facturation_country) exportRow[exportCols.facturation_country] = row.factures_destinataire_country ?? '';
        /* 63 */ if (exportCols.requests_type) exportRow[exportCols.requests_type] = row.requests_type_key_trad ?? '';
        /* 64 */ if (exportCols.reservation_date) exportRow[exportCols.reservation_date] = row.date_reservation ? new Date(row.date_reservation) : '';
        /* 65 */ if (exportCols.commission_rate) exportRow[exportCols.commission_rate] = parseFloat(row.hotels_societes_commission_rate) > 0 ? parseFloat(row.hotels_societes_commission_rate).toFixed(2) : '';
        /* 66 */ if (exportCols.commission_type) exportRow[exportCols.commission_type] = row.hotels_societes_commission_type_key_trad ?? '';
        /* 67 */ if (exportCols.currency) exportRow[exportCols.currency] = row.currency;
        /* 68 */ if (exportCols.moderation) exportRow[exportCols.moderation] = row.hasOwnProperty('requests_products_orders_moderation') ? (row.requests_products_orders_moderation ? 'yes'.trad() : 'no'.trad()) : '';
        /* 69 */ if (exportCols.date_decline) exportRow[exportCols.date_decline] = row.date_decline ? new Date(row.date_decline) : '';
        /* 70 */ if (exportCols.note) exportRow[exportCols.note] = row.requests_hotels_notes ? row.requests_hotels_notes.replace(/(\r\n|\n|\r)/gm, "") : '';
        /* 71 */ if (exportCols.forms_requests_name) exportRow[exportCols.forms_requests_name] = row.forms_requests_name ?? '';

        exportData.push(exportRow);
    });

    const getColumnPosition = (id) => Object.keys(exportData[0] ?? {}).indexOf(columns[id].label);
    let columnFormat = {
        date_with_hours: {},
        date_only: {},
        float: {}
    }
    // date with hours
    if (exportCols.date_activated) columnFormat.date_with_hours[getColumnPosition('date_activated')] = 'n';
    // date only
    if (exportCols.checkin) columnFormat.date_only[getColumnPosition('checkin')] = 'n';
    if (exportCols.checkout) columnFormat.date_only[getColumnPosition('checkout')] = 'n';
    if (exportCols.date_devis) columnFormat.date_only[getColumnPosition('date_devis')] = 'n';
    if (exportCols.reservation_date) columnFormat.date_only[getColumnPosition('reservation_date')] = 'n';
    if (exportCols.date_decline) columnFormat.date_only[getColumnPosition('date_decline')] = 'n';
    // float
    if (exportCols.requests_price) columnFormat.float[getColumnPosition('requests_price')] = 'n';
    if (exportCols.ca_request) columnFormat.float[getColumnPosition('ca_request')] = 'n';
    if (exportCols.total_ht) columnFormat.float[getColumnPosition('total_ht')] = 'n';
    if (exportCols.total_ttc) columnFormat.float[getColumnPosition('total_ttc')] = 'n';
    if (exportCols.subtotal_accomodation_ht) columnFormat.float[getColumnPosition('subtotal_accomodation_ht')] = 'n';
    if (exportCols.subtotal_accomodation_ttc) columnFormat.float[getColumnPosition('subtotal_accomodation_ttc')] = 'n';
    if (exportCols.subtotal_restauration_ht) columnFormat.float[getColumnPosition('subtotal_restauration_ht')] = 'n';
    if (exportCols.subtotal_restauration_ttc) columnFormat.float[getColumnPosition('subtotal_restauration_ttc')] = 'n';
    if (exportCols.subtotal_meeting_ht) columnFormat.float[getColumnPosition('subtotal_meeting_ht')] = 'n';
    if (exportCols.subtotal_meeting_ttc) columnFormat.float[getColumnPosition('subtotal_meeting_ttc')] = 'n';
    if (exportCols.subtotal_other_ht) columnFormat.float[getColumnPosition('subtotal_other_ht')] = 'n';
    if (exportCols.subtotal_other_ttc) columnFormat.float[getColumnPosition('subtotal_other_ttc')] = 'n';
    if (exportCols.subtotal_reductions_ht) columnFormat.float[getColumnPosition('subtotal_reductions_ht')] = 'n';
    if (exportCols.subtotal_reductions_ttc) columnFormat.float[getColumnPosition('subtotal_reductions_ttc')] = 'n';
    if (exportCols.subtotal_tourist_tax) columnFormat.float[getColumnPosition('subtotal_tourist_tax')] = 'n';
    if (exportCols.business_introducer_retrocession) columnFormat.float[getColumnPosition('business_introducer_retrocession')] = 'n';
    if (exportCols.business_introducer_estimated_commission) columnFormat.float[getColumnPosition('business_introducer_estimated_commission')] = 'n';
    if (exportCols.commission_rate) columnFormat.float[getColumnPosition('commission_rate')] = 'n';

    return {
        exportData,
        columnFormat
    };
}